import { attempt, set, cloneDeep, size, unset, get, has } from 'lodash'
import lsw from 'CORE/utils/local-storage-wrapper'

export default {
    computed: {
        querySorter() {
            if (has(this.$route.query, 'userSorter')) {
                return attempt(JSON.parse, get(this.$route.query, 'userSorter', '{}'))
            }
            if (lsw.has(`lastTableQuery.${this.$route.path}.userSorter`)) {
                return lsw.get(`lastTableQuery.${this.$route.path}.userSorter`)
            }
            return {}
        },
        queryFilter() {
            if (has(this.$route.query, 'userFilter')) {
                return attempt(JSON.parse, get(this.$route.query, 'userFilter', '{}'))
            }
            if (lsw.has(`lastTableQuery.${this.$route.path}.userSorter`)) {
                return lsw.get(`lastTableQuery.${this.$route.path}.userFilter`)
            }
            return {}
        },
        queryPager() {
            if (has(this.$route.query, 'userPager')) {
                return attempt(JSON.parse, get(this.$route.query, 'userPager', '{}'))
            }
            if (lsw.has(`lastTableQuery.${this.$route.path}.userSorter`)) {
                return lsw.get(`lastTableQuery.${this.$route.path}.userPager`)
            }
            return {}
        },
    },
    methods: {
        async onFilterChanged(e) {
            await this.setQueryValue('userFilter', size(e) ? JSON.stringify(e) : null)
            lsw.set(`lastTableQuery.${this.$route.path}.userFilter`, e)
        },
        async onSorterChanged(e) {
            await this.setQueryValue('userSorter', size(e) ? JSON.stringify(e) : null)
            lsw.set(`lastTableQuery.${this.$route.path}.userSorter`, e)
        },
        async onPageChanged(e) {
            await this.setQueryValue('userPager', size(e) ? JSON.stringify(e) : null)
            lsw.set(`lastTableQuery.${this.$route.path}.userPager`, e)
        },
        async setQueryValue(key, value) {
            const query = cloneDeep(this.$route.query)
            if (value === null) {
                unset(query, key)
            } else {
                set(query, key, value)
            }
            try {
                await this.$router.replace({ query })
            } catch (e) {
                console.warn(e)
            }
        },
    },
}
